import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { LOGGER_SERVICE } from 'src/app/logger/logger.config'
import { LoggerService } from 'src/app/logger/logger.interface'
import { FloApiResponse } from 'src/app/shared/models/api-response.model'
import { Node } from 'src/io/models/node'
import { PaginatedRequest } from './paginated-request'

/**
 * Convenience Wrapper to provide Injectable access to PaginatedRequest model
 */
@Injectable({
  providedIn: 'root'
})
export class PaginatedRequestService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(LOGGER_SERVICE) private readonly loggerService: LoggerService
  ) {}

  /**
   * @param baseUrl - api endpoint for requests, excluding query params
   * @param queryParams - query params to include with each request
   * @param externalFirstResponse - allow for use of an alternate response object
   * @param limit - number of items to request per page
   * @param initialIndex - page at which to start making requests
   * to use as the initial response, for use in cases where the first page of
   * data comes from a different source than `baseUrl`
   */
  public readonly getNewPaginatedRequest = (
    baseUrl: string,
    queryParams: Record<string, string> = {},
    externalFirstResponse?: FloApiResponse<ReadonlyArray<Node>>,
    limit = 15,
    initialIndex = 1
  ) =>
    new PaginatedRequest(
      this.httpClient,
      this.loggerService,
      baseUrl,
      limit,
      initialIndex,
      queryParams,
      externalFirstResponse
    )
}
